import { Route } from '@angular/router';
import { atNoInstagramBrowserGuard } from '@anothertrip/anothertrip-ds';

export const AUTH_ROUTES: Route[] = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: 'login',
    title: 'Sign in',
    loadComponent: () => import('../pages/login/login.page').then((c) => c.LoginPage),
  },
  {
    path: 'register',
    title: 'Sign up',
    loadComponent: () => import('../pages/register/register.page').then((c) => c.RegisterPage),
    canActivate: [atNoInstagramBrowserGuard],
  },
  {
    path: 'forgot-password',
    title: 'Forgot your password?',
    loadComponent: () => import('../pages/forgot-password/forgot-password.page').then((c) => c.ForgotPasswordPage),
  },
  {
    path: 'reset-password',
    title: 'Set a new password',
    loadComponent: () => import('../pages/reset-password/reset-password.page').then((c) => c.ResetPasswordPage),
  },
  {
    path: 'confirm-password-reset',
    title: 'Reset your password',
    loadComponent: () =>
      import('../pages/confirm-password-reset/confirm-password-reset.page').then((c) => c.ConfirmPasswordResetPage),
  },
  // {
  //   path: 'waitlist',
  //   loadComponent: () => import('../pages/waitlist/waitlist.page').then(c => c.WaitlistPage),
  // },
  {
    path: 'confirm-email',
    title: 'Confirm your account',
    loadComponent: () => import('../pages/confirm-email/confirm-email.page').then((c) => c.ConfirmEmailPage),
  },
];
